// extracted by mini-css-extract-plugin
export var active = "FormStepper-module--active--ba465";
export var backButton = "FormStepper-module--backButton--9add1";
export var backButtonContainer = "FormStepper-module--backButtonContainer--967de";
export var backButtonIcon = "FormStepper-module--backButtonIcon--f94ec";
export var completed = "FormStepper-module--completed--b16fc";
export var disabled = "FormStepper-module--disabled--3379f";
export var formStepperSection = "FormStepper-module--formStepperSection--7081b";
export var inactive = "FormStepper-module--inactive--1c1d4";
export var pending = "FormStepper-module--pending--ea9f4";
export var progressBar = "FormStepper-module--progressBar--3ba24";
export var progressItem = "FormStepper-module--progressItem--3feb5";
export var progressList = "FormStepper-module--progressList--434c1";
export var progressNav = "FormStepper-module--progressNav--24a16";
export var stepWrapper = "FormStepper-module--stepWrapper--12072";
export var stepsContainer = "FormStepper-module--stepsContainer--50f62";